import { render, staticRenderFns } from "./MaterialLabelPrintImageEdit.vue?vue&type=template&id=dd2ee384&scoped=true&"
import script from "./MaterialLabelPrintImageEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelPrintImageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2ee384",
  null
  
)

export default component.exports